import { defineStore } from 'pinia';
import { ref } from 'vue';

export const POLLING_INTERVAL_MS = 60000; // 60 seconds (1 minute)

export const useImmediateOutreachStore = defineStore(
  'immediateOutreach',
  () => {
    // Projects that have immediate outreach enabled (using Set for efficient lookups)
    const enabledProjectIds = ref<Set<number>>(new Set());

    // Polling state (not persisted)
    const pollingInterval = ref<number | null>(null);
    const pollingActive = ref<boolean>(false);

    return {
      enabledProjectIds,
      pollingInterval,
      pollingActive,
      POLLING_INTERVAL_MS,
    };
  },
  {
    persist: {
      serializer: {
        // Custom serializer to handle Set and exclude polling state
        deserialize: (value) => {
          const parsed = JSON.parse(value);
          // Only restore enabledProjectIds, reset polling state
          return {
            enabledProjectIds: parsed.enabledProjectIds
              ? new Set(parsed.enabledProjectIds)
              : new Set(),
            pollingInterval: null,
            pollingActive: false,
            POLLING_INTERVAL_MS,
          };
        },
        serialize: (value) => {
          // Only persist enabledProjectIds
          return JSON.stringify({
            enabledProjectIds: Array.from(value.enabledProjectIds),
          });
        },
      },
    },
  },
);
